import { render, staticRenderFns } from "./Expander.vue?vue&type=template&id=3fe02510&scoped=true&"
import script from "./Expander.vue?vue&type=script&lang=js&"
export * from "./Expander.vue?vue&type=script&lang=js&"
import style0 from "./Expander.vue?vue&type=style&index=0&id=3fe02510&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3fe02510",
  null
  
)

export default component.exports